import { LitElement, html } from '@hh/global.js'

class CollectionFilterDrawer extends LitElement {
  static properties = {
    open: {
      type: Boolean,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCloseTrigger()
    this.handleFilterInfoButtons()
    this.handleEscKey()

    document.addEventListener('plp:filter-update', () => {
      this.handleFilterInfoButtons()
      this.handleCloseTrigger()
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  isMobile() {
    return !window.matchMedia('(min-width: 768px)').matches
  }

  updated() {
    if (this.open && this.isMobile()) {
       document.body.classList.add('overflow-hidden');
    } else if (!this.open && this.isMobile()) {
       document.body.classList.remove('overflow-hidden');
    }
  }

  closeDrawer() {
    const filterButtonsEl = document.querySelectorAll('.js-toggle-filter-button')
    const filterDrawerEl = document.querySelector('collection-filter-drawer')
    const productGridContainer = document.querySelector('.js-collection-product-grid-container')
    filterDrawerEl.removeAttribute('open')
    productGridContainer.classList.remove('collection-product-grid__narrow')

    filterButtonsEl?.forEach((el) => {
      el.classList.remove('is-show')
    })
  }

  handleCloseTrigger() {
    const filterDrawerClose = this.querySelectorAll(
      '.js-collection-filter-drawer-close'
    )

    filterDrawerClose?.forEach((el) => {
      el.addEventListener('click', () => {
        this.closeDrawer()
      })
    })
  }

  handleFilterInfoButtons() {
    const filterButtonsEl = this.querySelectorAll('.js-filter-info-btn')

    filterButtonsEl.forEach((item) => {
      item.addEventListener('click', (e) => {
        const dataFilterInfo = item.dataset?.filterInfo
        const filterInfoDrawer = document.querySelector(
          `collection-filter-info[data-filter-category="${dataFilterInfo}"]`
        )

        filterInfoDrawer.setAttribute('open', true)
      })
    })
  }

  handleEscKey() {
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeDrawer()
      }
    })
  }

  render() {
    return html`<hh-focus-trap
      active="${!!this.open}"
      style="height: 100%">
      <slot></slot>
    </hh-focus-trap>`
  }
}

customElements.define('collection-filter-drawer', CollectionFilterDrawer)
